<template>
  <el-card
    v-loading="loading"
    shadow="never">
    <el-form
      ref="form"
      :rules="rules"
      :model="data"
      label-width="100px"
    >
      <el-form-item prop="loginName" label="用户名">
        <el-input  type="text" v-model="loginName"  readonly></el-input>
      </el-form-item>
      <el-form-item prop="oldPwd" label="旧密码">
        <el-input v-model="data.oldPwd" type="password" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="newPwd" label="新密码">
        <el-input v-model="data.newPwd" type="password" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="surePwd" label="确认密码">
        <el-input v-model="data.surePwd" type="password" autocomplete="off"></el-input>
      </el-form-item>
      <div class="tc">
        <el-button
          style="width: 140px;margin-right: 280px;"
          type="primary"
        @click="onSubmit">保存
        </el-button>
      </div>
    </el-form>
  </el-card>
</template>

<script>
import { system } from '../../api'
import {getSession} from '../../utils/session'
import {USER_ID, USER_NAME} from '../../constants'
export default {
  name: 'PwdEdit',
  mounted () {
  },
  data () {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value.length > 32) {
        callback(new Error('请输入少于32个字符'))
      } else {
        callback()
      }
    }
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入确认密码'))
      } else if (value.length > 32) {
        callback(new Error('请输入少于32个字符'))
      } else if (value !== this.data.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      loginName: getSession(USER_NAME),
      data: {
        sysUserId: getSession(USER_ID),
        oldPwd: '',
        newPwd: '',
        surePwd: ''
      },
      rules: {
        oldPwd: [
          {required: true, message: '请输入旧密码', trigger: 'blur'},
          {min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur'}
        ],
        newPwd: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
          {min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur'},
          {validator: validatePass, trigger: 'blur'}
        ],
        surePwd: [
          {required: true, message: '请输入确认密码', trigger: 'blur'},
          {min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur'},
          {validator: validatePass2, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.updatePwd()
        } else {
          return false
        }
      })
    },
    async updatePwd () {
      this.loading = true
      let {code, msg} = await system.changePwd({sysUserId: this.data.sysUserId, oldPwd: this.data.oldPwd, newPwd: this.data.newPwd})
      this.loading = false
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '修改密码成功'
        })
        this.$refs['form'].resetFields()
        this.data.oldPwd = ''
        this.data.newPwd = ''
        this.data.surePwd = ''
      } else {
        this.$message({
          type: 'error',
          message: msg
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-card {
    border: none;
    /deep/ .el-card__body {
      padding-top: 30px;
      .el-form {
        &.el-form--inline {
          width: 745px;
        }
        .el-form-item__content,
        .el-date-editor.el-input,
        .el-input--suffix {
          width: 232px;
        }
        .ipt-textarea {
          display: block;
          .el-form-item__content {
            width: 575px;
          }
        }
      }
      .el-upload,
      .el-upload--text {
        margin-left: 410px;
        margin-top: -58px;
      }
      .customizeCss {
        margin-top: -125px;
      }
      .customizeCssArea {
        margin-left: 307px;
        margin-top: -58px;
      }
    }
  }

  .el-input__icon {
    margin-right: 8px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    display: block;
    font-size: 14px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
